export interface ChallengeButtonTextParams {
  canPlay: boolean;
  isCompleted: boolean;
  isCurrentPeriod: boolean;
  challengeFrequency?: string;
}

export function getChallengeButtonText({
  canPlay,
  isCompleted,
  isCurrentPeriod,
  challengeFrequency,
}: ChallengeButtonTextParams): string {
  if (!canPlay) return 'Premium Access Required';
  if (isCompleted) return 'View Summary';
  if (!isCurrentPeriod) return 'Play This Challenge';
  if (challengeFrequency === 'daily') return "Play Today's Challenge";
  if (challengeFrequency === 'weekly') return "Play This Week's Challenge";
  return 'Play This Challenge';
}
